import React from 'react';
import { StickyBar } from './components/StickyBar';
import { Hero } from './components/Hero';
import { VslSection } from './components/VslSection';
import { Testimonials } from './components/Testimonials';
import { ProductBonuses } from './components/ProductBonuses';
import { PurchaseSection } from './components/PurchaseSection';
import { FaqSection } from './components/FaqSection';
export function App() {
  return <div className="min-h-screen w-full bg-cream font-sans text-ink" data-id="element-0" data-mp="2rlyqmg88cok1">
      <StickyBar data-id="element-1" data-mp="2mm2ji848kh09" />
      <Hero data-id="element-2" data-mp="2mmlwdaf14f7f" />
      <main data-id="element-3" data-mp="2mn5b6i9dunh8">
        <VslSection data-id="element-4" data-mp="2mndmw6trrmqu" />
        <Testimonials data-id="element-5" data-mp="2mjzm330r7lli" />
        <ProductBonuses data-id="element-6" data-mp="31agp2qt1ejki" />
        <PurchaseSection data-id="element-7" data-mp="31bs1ff0jszn8" />
        <FaqSection data-id="element-8" data-mp="31c1i2bzpdug9" />
      </main>
      <footer className="bg-forest-deep px-5 py-8 text-center text-xs text-cream/60" data-id="element-9" data-mp="2wk0ah3dhcrwk">
        © {new Date().getFullYear()} Legado Salud · El Escudo de Mamá. Este material es
        educativo y no sustituye la consulta con tu pediatra.
      </footer>
    </div>;
}